let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("asfB2")).then(() => parcelRequire('dMkI9'));